<template>
    <div id="home" :class="['home', {'-show-bg': showBg, '-blur': blur, '-is-mobile': isMobile, 'd-flex flex-column justify-content-center': coreParams.all_private_albums && +coreParams.all_private_albums}]">
        <div class="container">
            <div v-if="coreParams.all_private_albums && +coreParams.all_private_albums" class="hidden-album-box">
                <div class="hidden-album-box-title">{{ $t('private_gallery') }}</div>
                <div class="row">
                    <div class="col-md-7">
                        <div class="hidden-album-box-text">{{ $t('descriptions.personal_albums') }}</div>
                        <div v-if="coreParams.shop_design && coreParams.shop_design.info_text" class="hidden-album-box-text">
                            <hr><div v-html="coreParams.shop_design.info_text"></div>
                        </div>
                    </div>
                    <div class="col-md-5">
                        <hidden-album-form :label="!isMobile" position="top"/>
                    </div>
                </div>
            </div>
            <template v-else>
                <div class="row mb-3 mb-lg-5">
                    <div class="col-lg-4 offset-lg-8">
                        <hidden-album-form :label="!isMobile" position="left" border-radius="0"/>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-8">
                        <div v-if="coreParams.shop_design.startpage_text" class="home-content" v-html="coreParams.shop_design.startpage_text"></div>
                        <div v-else class="home-content text-center" v-text="$t('no_data')"></div>
                    </div>
                    <div class="col-lg-4">
                        <album-categories/>
                        <latest-albums v-if="!isMobile"/>
                    </div>
                </div>
            </template>
        </div>
        <powered-by v-if="hasPoweredBy"/>
        <vue-headful :title="headTitle($t('home'))"/>
    </div>
</template>

<style lang="scss">
    @import "../scss/variables";

    .home {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 160px 0 120px;
        min-height: 100%;
        flex-grow: 1;
        overflow: hidden;
        background-color: var(--bg-secondary-color);

        &::before {
            position: absolute;
            content: '';
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            opacity: 0;
            //transition: opacity 1s ease;
            background: var(--page-bg-color) var(--page-bg-image) 50% 50% no-repeat;
            background-size: cover;
            z-index: 0;
        }

        &.-is-mobile {
            padding-top: 120px;
            padding-bottom: 100px;

            .home-content {
                padding: 30px;
                font-size: .9rem;

                h1 {font-size: 1.7rem;}
                h2 {font-size: 1.55rem;}
                h3 {font-size: 1.45rem;}
                h4 {font-size: 1.30rem;}
                h5 {font-size: 1.15rem;}
                h5 {font-size: .9rem;}
            }
        }

        &.-show-bg::before {
            opacity: 1;
        }

        &.-blur::before {
            filter: blur($blur);
        }

        > * {
            position: relative;
            z-index: 1;
        }

        &-content {
            padding: 80px 110px;
            color: var(--text-color);
            background-color: var(--bg-color);

            & + .hidden-album-box {
                border-top: 1px solid var(--bg-color-dark);
            }
        }

        .input-group {

            .btn {

                .material-icon {
                    color: var(--text-color);
                }
            }
        }
    }
</style>

<script>
  import HiddenAlbumForm from '../components/HiddenAlbumForm.vue';
  import PoweredBy from '../components/PoweredBy.vue';
  import AlbumCategories from '../components/menu/AlbumCategories.vue';
  import LatestAlbums from '../components/menu/LatestAlbums.vue';

  import home from 'src/mixins/homePage';

  export default {
    mixins: [home],
    components: {
      HiddenAlbumForm,
      PoweredBy,
      AlbumCategories,
      LatestAlbums,
    },
  };
</script>
